// Real videos from the official TerrainHopper YouTube channel
const VIDEOS = [
  {
    id: "v1",
    title: "Taking on the forest — mud, logs and creek crossings",
    location: "Official TerrainHopper",
    embed: "https://www.youtube.com/embed/M5a0H5DwbLQ",
  },
  {
    id: "v2",
    title: "Three TerrainHoppers through the Lake District",
    location: "Lake District, UK",
    embed: "https://www.youtube.com/embed/XyjvmOHm-lg",
  },
  {
    id: "v3",
    title: "Overlander 4 driver tutorial & controls",
    location: "Official TerrainHopper",
    embed: "https://www.youtube.com/embed/orsidy-nZrs",
  },
];

export default function VideoGallery() {
  return (
    <section id="videos" data-testid="videos" className="relative py-24 md:py-32 bg-foreground text-background">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
              Action — Real Footage
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight font-bold leading-[1.05]">
              Sand. Mud. Forest. <br /><span className="text-primary">No drama.</span>
            </h2>
          </div>
          <p className="text-sm md:text-base text-background/70 max-w-md leading-relaxed">
            Real owners. Real terrain. Real tough. See the Overlander bring the adventure back to you.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map((v, idx) => (
            <article
              key={v.id}
              data-testid={`video-${idx}`}
              className={`group rounded-sm overflow-hidden border border-background/10 bg-background/[0.04] transition-all duration-300 hover:border-primary ${
                idx === 0 ? "lg:col-span-2 lg:row-span-1" : ""
              }`}
            >
              <div className="relative aspect-video bg-black">
                <iframe
                  data-testid={`video-iframe-${idx}`}
                  src={v.embed}
                  title={v.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 h-full w-full"
                />
              </div>
              <div className="p-5">
                <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-primary">
                  {v.location}
                </div>
                <h3 className="mt-2 font-display text-lg md:text-xl font-semibold leading-snug">
                  {v.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
